module.exports = __webpack_public_path__ + "static/media/upper.e6b89a0f.svg";